module.exports = __webpack_public_path__ + "img/currey-and-company.af502c7.jpg";